import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import PersonOutlineRoundedIcon from '@mui/icons-material/PersonOutlineRounded';
import { colorTokens } from '@eruvaka/web-pondlogs-base';
import { useTranslation } from '@eruvaka/web-pondlogs-i18n';
import { memo, useState, useId } from 'react';
import { useNavigate } from 'react-router-dom';
export const ProfileMenu = memo((props) => {
    const { t } = useTranslation('main');
    const { displayName, onSignOut, avatarUrl } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const popoverId = useId();
    const navigate = useNavigate();
    const isOpen = Boolean(anchorEl);
    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const initials = displayName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0].toUpperCase())
        .join('');
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { component: "button", onClick: handleOpen, "aria-haspopup": "listbox", "aria-expanded": isOpen, "aria-controls": isOpen ? popoverId : undefined, sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.75,
                    m: 0,
                    px: 1.5,
                    py: 0.75,
                    borderRadius: '999px',
                    border: 'none',
                    appearance: 'none',
                    WebkitAppearance: 'none',
                    bgcolor: 'transparent',
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    transition: 'background 0.15s',
                    outline: 'none',
                    '&:hover': { bgcolor: 'grey.100' },
                }, children: [_jsx(Avatar, { src: avatarUrl, sx: {
                            width: 24,
                            height: 24,
                            bgcolor: colorTokens.magenta,
                            color: 'common.white',
                            fontSize: 10,
                            fontWeight: 700,
                        }, children: initials || _jsx(PersonOutlineRoundedIcon, { sx: { fontSize: 14 } }) }), _jsx(Typography, { component: "span", sx: {
                            fontSize: 14,
                            fontWeight: 700,
                            color: 'primary.main',
                            lineHeight: 1,
                            userSelect: 'none',
                        }, children: displayName }), _jsx(KeyboardArrowDownIcon, { sx: {
                            fontSize: 16,
                            color: 'primary.main',
                            flexShrink: 0,
                            transition: 'transform 0.2s',
                            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        } })] }), _jsxs(Popover, { id: popoverId, open: isOpen, anchorEl: anchorEl, onClose: handleClose, disableScrollLock: true, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, slotProps: {
                    paper: {
                        sx: {
                            mt: 0.75,
                            minWidth: 180,
                            borderRadius: '14px',
                            border: '1px solid #e8edf2',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.10)',
                            overflow: 'hidden',
                        },
                    },
                }, children: [_jsxs(Box, { component: "button", onClick: () => {
                            navigate('/settings/profile-users');
                            handleClose();
                        }, sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.25,
                            width: '100%',
                            m: 0,
                            px: 2,
                            py: 1.25,
                            border: 'none',
                            borderBottom: '1px solid #f0f2f5',
                            appearance: 'none',
                            WebkitAppearance: 'none',
                            bgcolor: 'transparent',
                            cursor: 'pointer',
                            fontFamily: 'inherit',
                            textAlign: 'left',
                            transition: 'background 0.12s',
                            '&:hover': { bgcolor: '#f4f6f8' },
                        }, children: [_jsx(PersonOutlineRoundedIcon, { sx: { fontSize: 16, color: '#003C71', flexShrink: 0 } }), _jsx(Typography, { component: "span", sx: { flex: 1, fontSize: 13, fontWeight: 500, color: '#1a2233', lineHeight: 1 }, children: t('profile.profile', 'Profile') })] }), _jsxs(Box, { component: "button", onClick: () => {
                            onSignOut?.();
                            handleClose();
                        }, sx: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.25,
                            width: '100%',
                            m: 0,
                            px: 2,
                            py: 1.25,
                            border: 'none',
                            appearance: 'none',
                            WebkitAppearance: 'none',
                            bgcolor: 'transparent',
                            cursor: 'pointer',
                            fontFamily: 'inherit',
                            textAlign: 'left',
                            transition: 'background 0.12s',
                            '&:hover': { bgcolor: '#fff0f0' },
                        }, children: [_jsx(LogoutRoundedIcon, { sx: { fontSize: 16, color: '#d32f2f', flexShrink: 0 } }), _jsx(Typography, { component: "span", sx: { flex: 1, fontSize: 13, fontWeight: 500, color: '#d32f2f', lineHeight: 1 }, children: t('profile.signOut') })] })] })] }));
});
